export default __webpack_public_path__ + "static/media/TFA-PK-1036 copy.af0fb99a.jpg";